module.exports = __webpack_public_path__ + "src/assets/img/cmdProg8.93171efa.svg";